import React from 'react';
import styled from 'styled-components';
import Image from 'next/image';
import { resolvePath } from '@/utils/resolvePath';

const WhyAckodrive = (props: any) => {
    const { title, subText, whyLogo, reasons } = props;
    return (
        <WhyAckodriveWrapper id="show-cta">
            <WhyAckodriveTexts>
                <WhyAckodriveHeading
                    dangerouslySetInnerHTML={{ __html: title }}
                />
                {subText && (
                    <WhyAckodriveSubText>{subText}</WhyAckodriveSubText>
                )}
            </WhyAckodriveTexts>
            <WhyAckodriveStepsWrapper>
                {reasons?.map((reason: any) => {
                    return (
                        <StepWrapper>
                            {/* <ImageWrapper>
                                <Image
                                    src={resolvePath(
                                        '/images/seo/SideDesign.svg'
                                    )}
                                    width={120}
                                    height={120}
                                />
                            </ImageWrapper> */}
                            {whyLogo.data &&
                                (reason.title || reason.subText) && (
                                    <Image
                                        src={whyLogo.data.attributes.url}
                                        width={32}
                                        height={32}
                                    />
                                )}
                            {reason.title && (
                                <StepText>{reason.title}</StepText>
                            )}
                            {reason.subText && (
                                <StepSubText>{reason.subText}</StepSubText>
                            )}
                        </StepWrapper>
                    );
                })}
            </WhyAckodriveStepsWrapper>
        </WhyAckodriveWrapper>
    );
};

export default WhyAckodrive;

const WhyAckodriveWrapper = styled.div`
    display: flex;
    padding: 20px 16px 4px;
    flex-direction: column;
    align-items: center;
    gap: 20px;
    align-items: flex-start;
    background: var(--Grey-1, #121212);
`;
const WhyAckodriveTexts = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    align-self: stretch;
`;

const WhyAckodriveHeading = styled.h2`
    color: #fff;
    font-family: 'Euclid Circular B';
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: 28px;
    letter-spacing: -0.1px;
    margin: 0;
    align-self: stretch;
`;

const WhyAckodriveSubText = styled.div`
    color: #a6a6a6;
    font-family: 'Euclid Circular B';
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
`;

const WhyAckodriveStepsWrapper = styled.div`
    display: flex;
    gap: 16px;
    align-items: center;
    overflow-x: scroll;
    width: 100%;
    padding-bottom: 16px;
    scrollbar-width: none;
`;

const StepWrapper = styled.div`
    display: flex;
    width: 248px;
    padding: 16px;
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
    flex-shrink: 0;
    border-radius: 16px;
    background: rgba(255, 255, 255, 0.05);
    position: relative;
    overflow: hidden;
`;

const ImageWrapper = styled.div`
    position: absolute;
    right: 0;
    top: 0;
`;

const StepText = styled.div`
    color: #fff;
    font-family: 'Euclid Circular B';
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    line-height: 28px;
    letter-spacing: -0.1px;
    flex: 1 0 0;
`;

const StepSubText = styled.div`
    color: #a6a6a6;
    font-family: 'Euclid Circular B';
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    align-self: stretch;
`;
